const lineSeparator = ' \n';
const formTypes = [
  {
    name: 'TEST_DRIVE',
    headline: 'Ihr Weg zur Probefahrt',
    type: 'DWS Test Drive Request',
    campaign: 'MMD_Probefahrt_Probefahrtformular_HWS',
    action: 'TestDriveRequest',
    leadform: 'testDriveRequest',
    form_name: 'test_drive_request',
    consumptionText: 'leadFormTestDriveRequestConsumptionInfo',
    subHeadline:
      'Für die Planung Ihrer Probefahrt mit dem [[model]] benötigen wir Ihre Kontaktdaten. Mit * gekennzeichnete Eingaben sind Pflicht.',
    steps: [
      { number: '1', label: 'Modellauswahl', form_step: '1_model_selection' },
      { number: '2', label: 'Kontaktdaten', form_step: '2_contact_details' },
      { number: '3', label: 'Wunschtermin', form_step: '3_desired_date' },
      { number: '4', label: 'Übersicht', form_step: '4_overview' },
    ],
    comments: ({ currentModel, preferredTime, appointmentDateStringApi, comment }) =>
      [
        'Weitere Informationen:',
        `Probefahrtanfrage für: ${currentModel.name}`,
        'Händler gezielt ausgewählt oder automatische Zuordnung anhand Postleitzahl: Sie wurden gezielt vom Nutzer ausgewählt',
        preferredTime
          ? `Wunschtermin: ${preferredTime === 'morning' ? 'Vormittags' : 'Nachmittags'}, ${appointmentDateStringApi}`
          : `Wunschtermin: Beliebig, ${appointmentDateStringApi}`,
        comment ? `Kommentar: ${comment}` : undefined,
        `Ort der Leadabgabe: Probefahrtformular HWS (Nutzer befand sich auf folgender Seite als die Probefahrtanfrage gestellt wurde: ${window.location.toString().split('?')[0]})`,
        'Was ist zu tun: Bitte kontaktieren Sie den Interessenten zeitnah.',
        'PS: Die Leadbearbeitung direkt in MACS bietet Ihnen viele komfortable Funktionen, wie z.B. eine direkte Emailvorlage für die Vereinbarung eines Probefahrttermins oder die direkte Übernahme der Daten in Ihren Kontaktpool.',
      ]
        .filter(Boolean)
        .join(lineSeparator),
  },
  {
    name: 'REQUEST_FOR_PROPOSAL',
    headline: 'Ihre Angebotsanfrage',
    type: 'Order / pre-order',
    campaign: 'MMD_Angebotsanfrage_HWS',
    action: 'OrderPreOrder',
    leadform: 'requestAQuote',
    form_name: 'order_pre_order',
    consumptionText: 'leadFormRequestAQuoteConsumptionInfo',
    subHeadline:
      'Für die Erstellung Ihres individuellen Angebotes für den [[model]] benötigen wir Ihre Kontaktdaten. Mit * gekennzeichnete Eingaben sind Pflicht.',
    steps: [
      { number: '1', label: 'Modellauswahl', form_step: '1_model_selection' },
      { number: '2', label: 'Kontaktdaten', form_step: '2_contact_details' },
      { number: '3', label: 'Zusatzinfos', form_step: '3_additional_information' },
      { number: '4', label: 'Übersicht', form_step: '4_overview' },
    ],
    comments: ({ currentModel, comment, clientType, preferredPaymentOptions, preferredPayment }) =>
      [
        'Weitere Informationen:',
        `Angebotsanfrage für: ${currentModel.name}`,
        'Händler gezielt ausgewählt oder automatische Zuordnung anhand Postleitzahl: Sie wurden gezielt vom Nutzer ausgewählt',
        `Zusatzinformation: ${clientType === 'Private' ? 'Privatkunde' : 'Gewerbekunde'}`,
        `Zahlart: ${preferredPayment ? preferredPaymentOptions.find((ppo) => ppo.value === preferredPayment).label : 'Keine Angabe'}`,
        comment ? `Kommentar: ${comment}` : undefined,
        `Ort der Leadabgabe: Angebotsformular HWS (Nutzer befand sich auf folgender Seite als die Angebotsanfrage gestellt wurde: ${window.location.toString().split('?')[0]})`,
        'Was ist zu tun: Bitte kontaktieren Sie den Interessenten zeitnah.',
        'PS: Die Leadbearbeitung direkt in MACS bietet Ihnen viele komfortable Funktionen, wie z.B. eine direkte Emailvorlage für die Zusendung eines Angebotes oder die direkte Übernahme der Daten in Ihren Kontaktpool.',
      ]
        .filter(Boolean)
        .join(lineSeparator),
  },
  {
    name: 'NEWSLETTER',
    headline: 'NEWSLETTER ANMELDUNG',
    type: 'Newsletter request',
    campaign: 'MMD_Newsletter_HWS',
    action: 'newsletter',
    leadform: 'newsletter',
    form_name: 'newsletter',
    consumptionText: 'leadFormNewsletterInfo',
    subHeadline:
      'Wir halten Sie gerne zum neuen [[model]] auf dem Laufenden. Mit * gekennzeichnete Eingaben sind Pflicht für die Anmeldung zum Newsletter.',
    steps: [{ label: 'Kontaktdaten', form_step: 'form_open' }],
    comments: ({ currentModel, clientType }) =>
      [
        'Weitere Informationen:',
        `Newsletter Anmeldung für Modell ${currentModel.name}.`,
        'Händler gezielt ausgewählt oder automatische Zuordnung anhand Postleitzahl: Sie wurden gezielt vom Nutzer ausgewählt',
        `Zusatzinformation: ${clientType === 'Private' ? 'Privatkunde' : 'Gewerbekunde'}`,
        `Ort der Leadabgabe:  Newsletterformular HWS für Modell ${currentModel.name}. (Nutzer befand sich auf folgender Seite als die Angebotsanfrage gestellt wurde: ${window.location.toString().split('?')[0]})`,
        'Was ist zu tun: Wir haben den Kunden im Rahmen der Pre-Sale Kommunikationsstrecke für Sie angeschrieben und stellen ihnen diesen nun zur Verfügung.',
      ]
        .filter(Boolean)
        .join(lineSeparator),
  },
];

export { formTypes };
